var $503d2b80b5603cab$exports = {};
const $503d2b80b5603cab$var$successModal = document.querySelector(".modal-wrap");
const $503d2b80b5603cab$var$closeModal = document.querySelector(".modal-close");
const $503d2b80b5603cab$var$isEmailSent = localStorage.getItem("emailSent") === "true";
const $503d2b80b5603cab$var$emailFormElement = document.querySelector(".subscribe-email-form");
const $503d2b80b5603cab$var$emailInputElement = document.querySelector(".email-form-input");
const $503d2b80b5603cab$var$apiUrl = "https://api.herewallet.app/api/v1/web/blog_subscriptions";
const $503d2b80b5603cab$var$emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
if ($503d2b80b5603cab$var$isEmailSent) emailForm.style.display = "none";
const $503d2b80b5603cab$var$toggleModalSuccess = ()=>{
    if ($503d2b80b5603cab$var$successModal.style.display === "none") $503d2b80b5603cab$var$successModal.style.display = "block";
    else if ($503d2b80b5603cab$var$successModal.style.display === "block") $503d2b80b5603cab$var$successModal.style.display = "none";
    else $503d2b80b5603cab$var$successModal.style.display = "block";
};
if ($503d2b80b5603cab$var$emailFormElement) $503d2b80b5603cab$var$emailFormElement.addEventListener("submit", async function(e) {
    e.preventDefault();
    const emailSent = await $503d2b80b5603cab$var$sendEmailToApi($503d2b80b5603cab$var$emailInputElement.value);
    if (emailSent) {
        $503d2b80b5603cab$var$toggleModalSuccess();
        localStorage.setItem("emailSent", "true");
        $503d2b80b5603cab$var$emailFormElement.style.display = "none";
    }
    return false;
});
$503d2b80b5603cab$var$closeModal.addEventListener("click", $503d2b80b5603cab$var$toggleModalSuccess);
async function $503d2b80b5603cab$var$sendEmailToApi(email) {
    if (!$503d2b80b5603cab$var$emailPattern.test(email)) {
        const errorElement = document.querySelector(".form-error");
        errorElement.textContent = "Invalid email format";
        return false;
    }
    const requestOptions = {
        method: "POST",
        headers: {
            accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            email: email
        })
    };
    try {
        const dataFromApi = await fetch($503d2b80b5603cab$var$apiUrl, requestOptions).then((response)=>response.json()).then((data)=>{
            if (data.status !== "ok") throw Error();
            return true;
        }).catch(()=>{
            throw Error();
        });
        return dataFromApi;
    } catch (error) {
        console.error("Error sending email:", error);
        return false;
    }
}


//# sourceMappingURL=BLACKDRAGON-airdrop.6c22c5b4.js.map
